export default "<template>\n\n  <KTextbox\n    label=\"Clearable input\"\n    value=\"Hello there\"\n    clearable\n  />\n\n</template>\n";